import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a show/hide eye toggle on the right edge.
 * Behaves exactly like a native <input> so it drops into existing forms.
 *
 * Usage:
 *   <PasswordInput value={pwd} onChange={(e) => setPwd(e.target.value)} required />
 */
export default function PasswordInput({ className = "", "data-testid": testId, ...props }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? "text" : "password"}
        data-testid={testId}
        className={`rn3-input pr-10 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        tabIndex={-1}
        className="absolute right-0 top-0 h-full px-3 flex items-center justify-center text-[#737373] hover:text-[#8B1C22] focus:outline-none focus:text-[#8B1C22]"
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
